var global = window || global;
global.GLOBAL = global.global = global;

global.$ = function() {};
global._ = {};

global.application = {};

global.Module = {};

global.NS = function() {
    return arguments;
};

global.Class = function() {
    return arguments;
};

global.Static = function() {
    return arguments;
};

global.Data = {};

global.Security = {};

global.Cookie = {};


global.UI = {
    Plugin: {},
    Widget: {
        Forms: {
            Control: {}
        }
    },
    Map: {
        Layer: {}
    },
    Template: {},
    Cabinet: {},
    Admin: {},
    React: {},
    Renderer: {},
    Util: {}
};

global.Dict = {
    Data: {}
};

global.System = {};

global.Web = {};

global.Enum = {};

global.Events = function() {
    return arguments;
};

global.Html = {};

global.LongOperation = function() {
    return arguments;
};

global.Deferred = function() {
    return arguments;
};

global.Util = {};

global.Xhr = {};

global.Skeleton = {
    UI: {}
};

global.GISEX = {};

global.Tracking = {
    UI: {}
};

global.Trackers = {
    UI: {}
};

global.Dev = {
    UI: {}
};

global.Dev = {
    UI: {}
};

global.Glonass = {
    Data: {},
    Build: {},
    UI: {
        Admin: {}
    },
    GIS: {
        Layer: {}
    },
    Mobile: {
        UI: {}
    },
    Common: {}
};

global.Geo = {
    Data: {},
    UI: {
        Admin: {},
        Partial: {}
    },
    GIS: {
        Control: {},
        Layer: {}
    }
};

global.GISStand = {
    Data: {},
    UI: {
        Admin: {},
        Cabinet: {},
        Data: {},
        Partial: {},
        Spatial: {}
    },
    GIS: {
        Layer: {}
    }
};

global.Spatial = {
    Data: {},
    UI: {
        Admin: {},
        Dicts: {}
    }
};

global.SpatialMeta = {
    Data: {},
    UI: {}
};

global.GIS = {
    Data: {},
    UI: {
        Admin: {},
        Partial: {}
    },
    Map: {
        Layer: {
            Leaflet: {},
            OL3: {}
        },
        Control: {
            Leaflet: {},
            OL3: {}
        }
    }
};

global.Project = {
    Data: {},
    UI: {
        Admin: {}
    }
};

global.Social = {
    Data: {},
    UI: {}
};

global.Reports = {
    UI: {}
};

global.Accounting = {
    Data: {},
    UI: {}
};

global.Agronomy = {
    Data: {},
    UI: {
        Accounting: {},
        Admin: {},
        Cabinet: {
            Section: {}
        },
        Reports: {}
    }
};

global.EcoGen = {
    Data: {},
    UI: {
        Accounting: {},
        Admin: {},
        Cabinet: {
            Section: {},
        },
        Reports: {},
    },
}

global.Message = {};

global.Configuration = {};

global.ServerTime = {};

global.TextCase = {};

global.Kladr = {};

global.Department = {};

global.Sex = {};

global.State = {};

global.YesNo = {};

/**
 * Types definition for autocomplete and type hinting
 */
/**
 * @typedef {Object} glXHRResponse
 * @property {boolean} success
 * @property {Object} data
 * @property {string} message
 * @property {number} code
 */
var glXHRResponse;
/**
 * @typedef {Object} glStyle
 *
 * Shared
 * @property {string} title
 * @property {string|number[]} fillColor
 * @property {string|number[]} strokeColor
 * @property {number} strokeWidth
 * @property {number[]} strokeDash
 * @property {string} strokeCap
 * @property {string} strokeJoin
 * @property {number} zIndex
 *
 * Text only
 * @property {string} textFont
 * @property {number} textFontSize
 * @property {number} textScale
 * @property {string} textAlign
 * @property {number} textRotation
 * @property {number} textOffsetX
 * @property {number} textOffsetY
 *
 * Icon only
 * @property {string} iconUrl
 * @property {Image} iconImg
 * @property {number[]} iconSize
 * @property {number[]} iconImgSize
 * @property {number} iconOffset
 * @property {number[]} iconAnchor
 * @property {number} iconScale
 * @property {number} iconRotation
 * @property {number} iconRadius
 * @property {number} iconRadius1
 * @property {number} iconRadius2
 * @property {number} iconPoints
 * @property {number} iconAngle
 * @property {number} iconOpacity
 * @property {ol.style.IconOrigin | undefined} iconAnchorOrigin
 * @property {ol.Color | string | undefined} iconColor
 * @property {ol.style.IconOrigin | undefined} iconOffsetOrigin
 */
var glStyle;
/**
 * @typedef {Object< string, { title: string, styles: glStyle[] } >} glStyleHash
 */
var glStyleHash;

/**
 * @typedef {Object< string, ol.style.Style[] >} ol3StyleHash
 */
var ol3StyleHash;
